import React, { useEffect, useMemo } from "react";

import { DrupalOAuth } from "@parallelpublicworks/clf-utils";

const initialState = {
	isAuthenticated: null,
	clientId: null,
	baseUrl: null,
};

export const AuthContext = React.createContext(initialState);

const reducer = (state, action) => {
	switch (action?.type) {
		case "AUTHENTICATE_USER":
			return {
				...state,
				...action.payload,
				isAuthenticated: true,
			};
		case "LOGOUT_USER":
			return {
				...state,
				...action.payload,
				isAuthenticated: false,
			};
		default:
			return state;
	}
};

export const AuthContextProvider = (props) => {
	const auth = new DrupalOAuth(props);
	const [authState, dispatch] = React.useReducer(reducer, initialState);
	const isLoggedIn = useMemo(() => auth.isLoggedIn(), [auth.isLoggedIn()]);

	useEffect(() => {
		if (isLoggedIn) {
			dispatch({
				type: "AUTHENTICATE_USER",
				payload: {
					isAuthenticated: true,
					clientId: auth.getClientId(),
					baseUrl: auth.getBaseUrl(),
				},
			});
		} else {
			dispatch({
				type: "LOGOUT_USER",
				payload: {
					isAuthenticated: false,
					clientId: null,
					baseUrl: null,
				},
			});
		}
	}, [isLoggedIn]);

	if (authState.isAuthenticated === null) {
		// Add a loading screen here
		return null;
	}

	return (
		<AuthContext.Provider value={[authState, dispatch]}>
			{props.children}
		</AuthContext.Provider>
	);
};
